module.exports = __webpack_public_path__ + "img/yam_yes.c0379a01.png";